import BillingConfigGrid from '../../components/Budget/BillingConfigGrid';
import ConfigSaveBar from '../../components/Budget/ConfigSaveBar';
import LoadError from '../../components/Budget/LoadError';
import UnsavedEditsPrompt from '../../components/Budget/UnsavedEditsPrompt';
import { useConfigRowLabels } from '../../components/Budget/configEditIssues';
import { useGlobalBillingConfigs } from '../../hooks/api/budgetBillingConfig';
import { usePendingConfigEdits } from '../../hooks/usePendingConfigEdits';
import { useBudgetContext } from '../../store/Budget/BudgetContext';

// CALL-745: billing config is global master data. CALL-758: it is scoped to a bucket — the grid's
// bucket selector drives which bucket's rows are shown/edited; create/import/reassign all use it.
// CALL-779: cell edits collect here and are written by one Save, so the page owns the pending set.
const BudgetBillingConfig = () => {
    // CALL-758: the grid's bucket selector drives which bucket's rows show; "All buckets"
    // (selectedBucketId undefined) lists every bucket's configs — handy for reassigning via the
    // editable bucket column.
    const { selectedBucketId, canEdit } = useBudgetContext();
    const [billingConfigs, isLoading, { isError, error, refetch }] = useGlobalBillingConfigs(selectedBucketId);
    // Deliberately NOT reset when the bucket filter changes: the rows a bucket switch hides are still
    // pending and still saved, since the store is keyed by config id rather than by what is on screen.
    const pending = usePendingConfigEdits();
    // Accumulated, so the save bar can still NAME a blocking row after a bucket switch has taken it out
    // of the query's response.
    const rowLabels = useConfigRowLabels(billingConfigs);

    if (isError) return <LoadError error={error} onRetry={refetch} />;

    return (
        <>
            <BillingConfigGrid billingConfigs={billingConfigs} isLoading={isLoading} pending={pending} />
            {/* Outside the canEdit branch: the guard must not disappear together with the save bar if the
                permission flips while edits are pending — that is the arrangement that lost the Overview's
                edits before UnsavedEditsPrompt was extracted. */}
            <UnsavedEditsPrompt isDirty={pending.hasEdits} />
            {canEdit && (
                <ConfigSaveBar
                    pending={pending}
                    rowLabels={rowLabels}
                    legendCues={['editable', 'unsaved', 'orphaned']}
                />
            )}
        </>
    );
};

export default BudgetBillingConfig;
